/* eslint-disable boundaries/element-types */
import { GeckoAssetModelType, GeckoComponentModelType } from 'types'

type InspectionDefaultValues = {
  inspection_type: string
  ndt_method_type: string
  units: string
  num_points: number
  x_bin_size: number
  y_bin_size: number
  robot_types: string[]
  plot_rotation: number | undefined
  sensor_offset: number
  angle_variable: string
  angle_plot_settings: string[]
  sensor_spacing: number
  validation_thickness: string
  display_component_type_id: number
  vertical_runs: boolean
  low_threshold_relative_to_nominal: number
  high_threshold_relative_to_nominal: number
}

const boilerDefaults = {
  inspection_type: 'rug',
  ndt_method_type: 'ut',
  units: 'ft-in',
  num_points: 1,
  x_bin_size: 1,
  y_bin_size: 1,
  robot_types: ['TOKA 4'],
  plot_rotation: 0,
  sensor_offset: 1,
  angle_variable: 'tube',
  angle_plot_settings: ['1'],
  sensor_spacing: 3,
  validation_thickness: 'thickness_bootsy',
  display_component_type_id: 1,
  low_threshold_relative_to_nominal: -0.04,
  high_threshold_relative_to_nominal: -0.01,
  vertical_runs: true,
}
const tankShellDefaults = {
  inspection_type: 'rug',
  ndt_method_type: 'ut',
  units: 'ft-in',
  num_points: 1,
  x_bin_size: 0.25,
  y_bin_size: 0.25,
  robot_types: ['TOKA 4'],
  plot_rotation: undefined,
  sensor_offset: 1,
  angle_variable: 'position',
  angle_plot_settings: ['1'],
  sensor_spacing: 1,
  validation_thickness: 'thickness_bootsy',
  display_component_type_id: 2,
  vertical_runs: true,
  low_threshold_relative_to_nominal: -0.04,
  high_threshold_relative_to_nominal: -0.01,
}

const coneDefaults = {
  inspection_type: 'rug',
  ndt_method_type: 'ut',
  units: 'ft-in',
  num_points: 1,
  x_bin_size: 5,
  y_bin_size: 0.25,
  robot_types: ['TOKA 4'],
  plot_rotation: 90,
  sensor_offset: 12.5,
  angle_variable: 'angle',
  angle_plot_settings: ['1'],
  sensor_spacing: 1,
  validation_thickness: 'thickness_bootsy',
  display_component_type_id: 3,
  low_threshold_relative_to_nominal: -0.04,
  high_threshold_relative_to_nominal: -0.01,
  vertical_runs: true,
}

const tankFloorDefaults = {
  inspection_type: 'rug',
  ndt_method_type: 'ut',
  units: 'ft-in',
  num_points: 1,
  x_bin_size: 0.25,
  y_bin_size: 0.25,
  robot_types: ['TOKA 4'],
  plot_rotation: undefined,
  sensor_offset: 1,
  angle_variable: 'position',
  angle_plot_settings: ['1'],
  sensor_spacing: 1,
  validation_thickness: 'thickness_bootsy',
  display_component_type_id: 4,
  vertical_runs: true,
  low_threshold_relative_to_nominal: -0.04,
  high_threshold_relative_to_nominal: -0.01,
}

const pipeSectionDefaults = {
  inspection_type: 'rug',
  ndt_method_type: 'ut',
  units: 'ft-in',
  num_points: 1,
  x_bin_size: 0.25,
  y_bin_size: 0.25,
  robot_types: ['TOKA 4'],
  plot_rotation: undefined,
  sensor_offset: 1,
  angle_variable: 'position',
  angle_plot_settings: ['1'],
  sensor_spacing: 1,
  validation_thickness: 'thickness_bootsy',
  display_component_type_id: 5,
  vertical_runs: true,
  low_threshold_relative_to_nominal: -0.04,
  high_threshold_relative_to_nominal: -0.01,
}

export const unknownDefaults = {
  inspection_type: 'rug',
  ndt_method_type: 'ut',
  units: 'ft-in',
  num_points: 1,
  x_bin_size: 0.25,
  y_bin_size: 0.25,
  robot_types: ['TOKA 4'],
  plot_rotation: undefined,
  sensor_offset: 1,
  angle_variable: 'position',
  angle_plot_settings: ['1'],
  sensor_spacing: 1,
  validation_thickness: 'thickness_bootsy',
  display_component_type_id: 2,
  vertical_runs: true,
  low_threshold_relative_to_nominal: -0.04,
  high_threshold_relative_to_nominal: -0.01,
}

// tank floor and roof dont have an asset model type but they
// have the same defaults -> display component id is the field
export const inspectionDefaultsMap = new Map<string, InspectionDefaultValues>([
  // use same defaults for vertical and horizontal tanks
  [GeckoAssetModelType.VerticalTank, tankShellDefaults],
  [GeckoAssetModelType.HorizontalTank, tankShellDefaults],
  [GeckoAssetModelType.LegacyBoiler, boilerDefaults],
  [GeckoAssetModelType.Piping, pipeSectionDefaults],
  // there are no defaults defined for a ship
  [GeckoAssetModelType.Ship, unknownDefaults],
  // there are no defaults defined for a missile Sile
  [GeckoAssetModelType.MissileSilo, unknownDefaults],

  //Component Model defaults
  [GeckoComponentModelType.VerticalTankShell, tankShellDefaults],
  [GeckoComponentModelType.HorizontalTankShell, tankShellDefaults],
  [GeckoComponentModelType.PipeSection, pipeSectionDefaults],
  [GeckoComponentModelType.LegacyBoilerWalls, boilerDefaults],
  [GeckoComponentModelType.ShipDeck, unknownDefaults],
  //since a tank floor  and tank roof are almost the same, we can use the same defaults
  [GeckoComponentModelType.TankFloor, tankFloorDefaults],
  [GeckoComponentModelType.TankFlatRoof, tankFloorDefaults],
  [GeckoComponentModelType.LegacyCone, coneDefaults],
  [GeckoComponentModelType.LaunchTube, unknownDefaults],
  ['Unknown', unknownDefaults],
])
